import React from 'react';
import { Button, Heading, Icon, Modal, ModalCloser, ModalContent, Text } from '@teliaee/design-system';
import useStores from '../stores/UseStores';
import { observer } from 'mobx-react';
import { useIsTabletHook } from '../util/hooks/useIsMobile';

const PasskeyOfferRegisterResultModal = observer(() => {
  const {
    passkeyStore: { offerRegisterModalVisible, wasPasskeyRegisterSuccessful, registerErrorState, register, offerRegisterModalOnComplete },
    translateStore: { translate },
  } = useStores();
  const { isTablet } = useIsTabletHook();

  const handleClose = () => {
    offerRegisterModalOnComplete();
  };

  const handleRetry = async () => {
    await register();
  };

  const modalState = (() => {
    if (wasPasskeyRegisterSuccessful === null) {
      return null;
    }

    if (wasPasskeyRegisterSuccessful) {
      return {
        icon: '#check-round',
        iconClass: 'c-success-text',
        title: translate('passkey.offerRegister.result.success.title'),
        description: translate('passkey.offerRegister.result.success.text'),
        actions: (
          <ModalCloser>
            <Button variant="secondary" text={translate('passkey.offerRegister.result.close')} onClick={handleClose} />
          </ModalCloser>
        ),
      };
    }

    if (registerErrorState === null) {
      return null;
    }

    return {
      icon: '#alert',
      iconClass: 'c-error-text',
      title: translate(`passkey.offerRegister.result.error.${registerErrorState.errorType}.title`),
      description: translate(`passkey.offerRegister.result.error.${registerErrorState.errorType}.description`),
      actions: registerErrorState.canRetry ? (
        <Button variant="secondary" text={translate('passkey.offerRegister.result.retry')} iconLeft="#refresh" onClick={handleRetry} />
      ) : (
        <ModalCloser>
          <Button variant="secondary" text={translate('passkey.offerRegister.result.close')} onClick={handleClose} />
        </ModalCloser>
      ),
    };
  })();

  if (modalState === null) {
    return null;
  }

  return (
    <Modal isOpen={offerRegisterModalVisible} isFullHeight={!isTablet} onClose={offerRegisterModalOnComplete}>
      <ModalContent>
        <Text className="text-center">
          <Icon size="lg" modifiers={modalState.icon} className={modalState.iconClass} />
          <Heading level={1} className="h3">
            {modalState.title}
          </Heading>
          <p>{modalState.description}</p>
          {modalState.actions}
        </Text>
      </ModalContent>
    </Modal>
  );
});

export default PasskeyOfferRegisterResultModal;
